import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import React, { Fragment, Suspense, lazy } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// non lazy loaded components
import Home from "./pages/Dashboard/Home";
import SettingsList from "./pages/Setting/SettingsList";
import ETemplates from "./pages/Email/index";
import Application from "./pages/Application/Application";
import Organization from "./pages/Organization/Organization";
import ForgotPassword from "./pages/Auth/ForgotPassword";
import ResetPassword from "./pages/Auth/ResetPassword";
import Login from "./pages/Auth/Login";
import ProtectedRoute from "./utils/ProtectedRoute";

// lazy loaded components
const OrganizationDetails = lazy(() =>
  import("./pages/Organization/OrganizationDetails")
);
const AddOrganization = lazy(() =>
  import("./pages/Organization/AddOrganization")
);
const EditOrganization = lazy(() =>
  import("./pages/Organization/EditOrganization")
);
const ManageBackendUser = lazy(() =>
  import("./pages/Backendusers/ManageBackendUser")
);
const Index = lazy(() => import("./pages/Backendusers/Index"));
const Profile = lazy(() => import("./pages/Backendusers/Profile"));
const ManageETemplates = lazy(() => import("./pages/Email/Manage"));
const UserLoginCount = lazy(() => import("./pages/Setting/UserLoginCount"));

function App(props) {
  return (
    <Router>
      <Fragment>
        <Routes>
          {/* Public Routes */}
          <Route exact path="/" element={<Login />} />
          <Route exact path="/forgotPassword" element={<ForgotPassword />} />
          <Route exact path="/resetPassword" element={<ResetPassword />} />

          {/* Protected Routes */}
          <Route path="/" element={<ProtectedRoute />}>
            <Route exact path="/home" element={<Home />} />
            <Route exact path="/settings" element={<SettingsList />} />
            <Route exact path="/eTemplates" element={<ETemplates />} />
            <Route exact path="/applications" element={<Application />} />
            <Route exact path="/organizations" element={<Organization />} />

            <Route
              exact
              path="/organization/:id"
              element={
                <Suspense fallback={<div>Loading...</div>}>
                  <OrganizationDetails />
                </Suspense>
              }
            />
            <Route
              exact
              path="/organization/edit/:id"
              element={
                <Suspense fallback={<div>Loading...</div>}>
                  <EditOrganization />
                </Suspense>
              }
            />
            <Route
              exact
              path="/organization/new"
              element={
                <Suspense fallback={<div>Loading...</div>}>
                  <AddOrganization />
                </Suspense>
              }
            />

            <Route
              exact
              path="/eTemplates/:id"
              element={
                <Suspense fallback={<div>Loading...</div>}>
                  <ManageETemplates />
                </Suspense>
              }
            />

            {/* Backend User Routes */}
            <Route
              exact
              path="/backendusers"
              element={
                <Suspense fallback={<div>Loading...</div>}>
                  <Index />
                </Suspense>
              }
            />
            <Route
              exact
              path="/createBackendUser"
              element={
                <Suspense fallback={<div>Loading...</div>}>
                  <ManageBackendUser />
                </Suspense>
              }
            />
            <Route
              exact
              path="/editBackendUser/:id"
              element={
                <Suspense fallback={<div>Loading...</div>}>
                  <ManageBackendUser />
                </Suspense>
              }
            />
            <Route
              exact
              path="/adminProfile"
              element={
                <Suspense fallback={<div>Loading...</div>}>
                  <Profile />
                </Suspense>
              }
            />

            <Route
              exact
              path="/userLoginLogs"
              element={
                <Suspense fallback={<div>Loading...</div>}>
                  <UserLoginCount />
                </Suspense>
              }
            />
          </Route>
        </Routes>
        <ToastContainer />
      </Fragment>
    </Router>
  );
}

export default App;
